import React, { useContext, useEffect, useRef, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { UserContext } from '../../App';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { LoadBooks } from '../searchBooks/loadBooks';
import { LoadingFull } from '../loading';
import { FaArrowRightLong } from "react-icons/fa6";
import { IoIosArrowBack } from "react-icons/io";
import axios from 'axios';

export const BookList = ({ data }) => {
  const { user } = useContext(UserContext)

  function CustomArrow({ direction, onClick }) {
    return (
      <div
        className={`absolute top-1/2 -translate-y-1/2 z-10 cursor-pointer 
          w-10 md:w-12 h-10 md:h-12 flex items-center justify-center rounded-full
          bg-white shadow-lg transition text-lg md:text-xl
          ${direction === 'left' ? '-left-2 sm:-left-5 md:-left-10 lg:-left-16' : '-right-2 sm:-right-5 md:-right-10 lg:-right-16'}
        `}
        onClick={onClick}
      >
        <IoIosArrowBack className={direction === 'left' ? "" : "rotate-180"} />
      </div>
    );
  }

  const settings = {
    dots: false,
    infinite: true,
    speed: 200,
    slidesToShow: 8,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    nextArrow: <CustomArrow direction="right" />,
    prevArrow: <CustomArrow direction="left" />,
    swipe: false,
    draggable: false,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1750, // Skærme mindre end 1280px
        settings: {
          slidesToShow: 7,
        },
      },
      {
        breakpoint: 1500, // Skærme mindre end 1280px
        settings: {
          slidesToShow: 6,
        },
      },
      {
        breakpoint: 1280, // Skærme mindre end 1280px
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1024, // Skærme mindre end 1024px
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768, // Skærme mindre end 768px (tablets)
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480, // Skærme mindre end 480px (mobil)
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return (
    typeof data !== 'undefined' ?
      <Slider {...settings}>
        {data.filter(book => (typeof user !== 'undefined' ? book.dbBook.ejer !== user._id : typeof book !== 'undefined')).map((book) => (
          <div className="px-1 h-full">
            <Link to={`/bøger/${book.dbBook._id}`}>
              <div className="book cursor-pointer h-full flex flex-col gap-2 justify-between">
                <div className="flex flex-col gap-2">
                  <div className="w-full h-56 bg-neutral-100 p-2">
                    <img src={`https://firebasestorage.googleapis.com/v0/b/bolig2.appspot.com/o/${book.dbBook['_id']}%2F0?alt=media`} className="h-full w-auto object-contain m-auto" alt="Slide 1" />
                  </div>
                  <div className="flex flex-col">
                    <h5 className="text-sm md:text-sm xl:text-base text-gray-700 font-medium break-words">{book.apiBook.title}</h5>
                    <p className="text-sm text-gray-700 font-normal line-clamp-2">{book.apiBook.director.map((dir, index) => {
                      if (index !== 0) {
                          return `, ${dir['$']}`
                      } else {
                          return ` ${dir['$']}`
                      }
                    })}</p>
                  </div>
                </div>
                <p className="text-base font-medium select-none">{Number(book.dbBook.price/100).toFixed(2).toString().replace(/\./g, ',')} kr.</p>
              </div>
            </Link>
          </div>
        ))}
      </Slider>
    :
      <div className="h-36">
        <LoadingFull />
      </div>
  )
}